import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';
import ForretningInvolvertList from './ForretningInvolvertList.jsx';
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Forretning extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleForretning = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var forretning = this.props.forretning
        var enableOmnummerert = ["OP", "SF", "OA", "ON", "JS", "FE", "DL", "OM"].includes(forretning.forretningstype.substring(0, 2))
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleForretning}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title"><Moment local>{forretning.forretningsdokumentdato}</Moment> {forretning.forretningsklasse}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('forretningstype')}</div>
                            <div className="value">{forretning.forretningstype}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('forretningsdokumentdato')}</div>
                            <div className="value"><Moment local>{forretning.forretningsdokumentdato}</Moment></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('matrikkelforingsdato')}</div>
                            <div className="value"><Moment local>{forretning.matrikkelforingsdato}</Moment></div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kommunalsaksreferanse')}</div>
                            <div className="value">{forretning.kommunalSaksreferanse}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('annenreferanse')}</div>
                            <div className="value">{forretning.annenReferanse}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('signatur')}</div>
                            <div className="value">{forretning.signatur}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('tinglysingsstatus')}</div>
                            <div className="value">{forretning.tinglysingsstatus}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('tinglysingsstatusendret')}</div>
                            <div className="value"><Moment local>{forretning.tinglysingsstatusEndretDato}</Moment></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('rolle')}</div>
                            <div className="value">{forretning.rolle}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('arealendring')}</div>
                            <div className="value">{forretning.arealendring}</div>
                        </div>
                    </div>
                    { enableOmnummerert &&
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('omnummerertfra')}</div>
                            <div className="value">{forretning.omnummerertfra}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('omnummererttil')}</div>
                            <div className="value">{forretning.omnummererttil}</div>
                        </div>
                    </div>}
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('jordskiftereferanse')}</div>
                            <div className="value">{forretning.jordskifteReferanse}</div>
                        </div>
                    </div>
                    { forretning.tilMatrikkelenhet &&
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('framatrikkelenhet')}</div>
                            <div className="value">{forretning.fraMatrikkelenhet}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('tilmatrikkelenhet')}</div>
                            <div className="value">{forretning.tilMatrikkelenhet}</div>
                        </div>
                    </div>}
                    { forretning.antallInvolverte > 0 &&
                    <ul>
                        <ForretningInvolvertList forretningId={forretning.forretningId} antall={forretning.antallInvolverte} token={this.props.token} settings={this.props.settings} />
                    </ul>
                    }
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Forretning)